"use client";

// L'entrée de minibreek : un mot de passe, qui dit aussi qui entre (app/comptes.py). Rien d'autre ne se monte avant,
// pour que l'espace n'ouvre ni flux ni requête sans session. Sans comptes (l'API du Mac), on entre tout de suite.
// Une requête refusée plus tard (session échue) ramène ici : lib/api l'annonce par l'événement SESSION.

import { useEffect, useRef, useState } from "react";
import { API, SESSION } from "@/lib/api";

type Etat = "verif" | "dedans" | "dehors";

export function Entree({ children }: { children: React.ReactNode }) {
  const [etat, setEtat] = useState<Etat>("verif");
  const [mot, setMot] = useState("");
  const [erreur, setErreur] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);
  const champ = useRef<HTMLInputElement>(null);

  useEffect(() => {
    fetch(`${API}/api/session`, { cache: "no-store" })
      .then((r) => setEtat(r.ok ? "dedans" : "dehors"))
      .catch(() => setEtat("dehors"));
    const sortir = () => setEtat("dehors");
    window.addEventListener(SESSION, sortir);
    return () => window.removeEventListener(SESSION, sortir);
  }, []);

  useEffect(() => {
    if (etat === "dehors") champ.current?.focus();
  }, [etat]);

  if (etat === "dedans") return <>{children}</>;
  if (etat === "verif") return null;

  const entrer = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!mot || envoi) return;
    setEnvoi(true);
    setErreur(null);
    try {
      const r = await fetch(`${API}/api/connexion`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ mot_de_passe: mot }),
      });
      if (r.ok) {
        setMot("");
        setEtat("dedans");
        return;
      }
      setErreur(r.status === 401 ? "Mot de passe incorrect." : "L'API ne répond pas, réessayez.");
    } catch {
      setErreur("L'API ne répond pas, réessayez.");
    } finally {
      setEnvoi(false);
    }
    champ.current?.select();
  };

  return (
    <main className="entree">
      <form className="entree-cadre" onSubmit={entrer}>
        <span className="entree-marque">
          <svg className="logo-briques" viewBox="0 0 26 20" aria-hidden>
            <rect className="ocre" x="2" y="1" width="15" height="5" rx="2" />
            <rect className="rouge" x="8" y="7.5" width="15" height="5" rx="2" />
            <rect className="noire" x="2" y="14" width="15" height="5" rx="2" />
          </svg>
          minibreek
        </span>
        <label htmlFor="entree-mot">Mot de passe</label>
        <input
          ref={champ}
          id="entree-mot"
          type="password"
          autoComplete="current-password"
          value={mot}
          onChange={(e) => setMot(e.target.value)}
          aria-invalid={erreur ? true : undefined}
          aria-describedby={erreur ? "entree-erreur" : undefined}
        />
        {erreur && (
          <p id="entree-erreur" className="entree-erreur" role="alert">
            {erreur}
          </p>
        )}
        <button type="submit" disabled={!mot || envoi}>
          {envoi ? "Vérification…" : "Entrer"}
        </button>
      </form>
    </main>
  );
}
